module.exports = __webpack_public_path__ + "static/media/dinkominfo.49ad7a63.png";